// extracted by mini-css-extract-plugin
export default {"wrapper":"Voucher_wrapper__CS3uW","wrapper-hover":"Voucher_wrapper-hover__e1ERY"};